import styled, { css, keyframes } from 'styled-components';

export type ButtonProps = {
  $secondary?: boolean;
  $disabled?: boolean;
  $isLoading?: boolean;
  $fullWidth?: boolean;
};

const primaryButton = css<ButtonProps>`
  background-color: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.white};
  border: none;

  ${({ theme, $disabled, $isLoading }) =>
    $disabled &&
    !$isLoading &&
    css`
      background-color: ${theme.colors.greyWarm['80']};
      transition: 0;
      cursor: auto;

      &:hover {
        filter: brightness(1);
      }
    `}
`;

const secondaryButton = css<ButtonProps>`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.lightBlue};
  border: ${({ theme }) => `1px solid ${theme.colors.lightBlue}`};

  ${({ theme, $disabled, $isLoading }) =>
    $disabled &&
    !$isLoading &&
    css`
      background-color: ${theme.colors.greyWarm['40']};
      transition: 0;

      &:hover {
        filter: brightness(1);
      }
    `}
`;

export const StyledButton = styled.button<ButtonProps>`
  position: relative;
  transition: background-color 0.3s ease, color 0.3s ease, border 0.3s ease,
    filter 0.3s ease;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  height: 52px;
  line-height: 52px;
  padding: 0 16px;
  appearance: none;
  outline: 0;
  cursor: pointer;

  &:hover {
    filter: brightness(0.95);
  }

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      display: block;
    `}

  ${({ $secondary }) => (!$secondary ? primaryButton : secondaryButton)};
`;

const animateRipple = keyframes`
  from {
    opacity: 1;
    transform: scale(0);
  }
  to {
    opacity: 0;
    transform: scale(10);
  }
`;

export const RippleContainer = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;

  .ripple {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100px;
    height: 100px;
    margin-top: -50px;
    margin-left: -50px;
    animation: ${animateRipple} 1.25s;
    opacity: 0;
  }
`;

export const Content = styled.span<{ $isLoading?: boolean }>`
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
`;
